import CategoryIcon from '@mui/icons-material/FolderShared';

import { DirectoryCategoryList } from './DirectoryCategoryList';
import { DirectoryCategoryEdit } from './DirectoryCategoryEdit';
import { DirectoryCategoryCreate } from './DirectoryCategoryCreate';

export default {
    list: DirectoryCategoryList,
    edit: DirectoryCategoryEdit,
    create: DirectoryCategoryCreate,
    icon: CategoryIcon,
};
